module.exports = __webpack_public_path__ + "img/check.a46bbe71.svg";